import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SugargooGuidePage from "../pages/article/page";
import BestSpreadsheet2026 from "../pages/articles/BestSpreadsheet2026";
import UpdatedSpreadsheet from "../pages/articles/UpdatedSpreadsheet";
import SpreadsheetByCategory from "../pages/articles/SpreadsheetByCategory";
import SpreadsheetBrands from "../pages/articles/SpreadsheetBrands";
import QCGuide from "../pages/articles/QCGuide";
import ShippingGuide from "../pages/articles/ShippingGuide";
import SafetyGuide from "../pages/articles/SafetyGuide";
import BeginnerGuide from "../pages/articles/BeginnerGuide";
import BudgetFinds from "../pages/articles/BudgetFinds";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <SugargooGuidePage />,
  },
  {
    path: "/best-sugargoo-spreadsheet-2026",
    element: <BestSpreadsheet2026 />,
  },
  {
    path: "/updated-sugargoo-spreadsheet",
    element: <UpdatedSpreadsheet />,
  },
  {
    path: "/sugargoo-spreadsheet-by-category",
    element: <SpreadsheetByCategory />,
  },
  {
    path: "/sugargoo-spreadsheet-brands",
    element: <SpreadsheetBrands />,
  },
  {
    path: "/sugargoo-qc-guide",
    element: <QCGuide />,
  },
  {
    path: "/sugargoo-shipping-guide",
    element: <ShippingGuide />,
  },
  {
    path: "/sugargoo-safety-guide",
    element: <SafetyGuide />,
  },
  {
    path: "/sugargoo-beginner-guide",
    element: <BeginnerGuide />,
  },
  {
    path: "/best-budget-finds-sugargoo",
    element: <BudgetFinds />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;